import { create } from 'zustand';

interface SessionState {
  isSessionExpired: boolean;
  setSessionExpired: (isExpired: boolean) => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  isSessionExpired: false,
  setSessionExpired: (isExpired) => set({ isSessionExpired: isExpired }),
}));
